import { useBFF } from '~/composables/useBFF/useBFF';
import useUiNotification from '~/composables/useUiNotification';

export const useForm = () => {
  const { $contacts } = useBFF();
  const { send } = useUiNotification();

  const loading = ref(false);
  const errors = ref(false);

  const sendEmail = async (form: Record<string, unknown>): Promise<boolean> => {
    loading.value = true;
    errors.value = false;
    try {
      const { errors: apiErrors } = await $contacts.sendEmail(form);

      if (apiErrors?.length) {
        throw new Error();
      }

      send({
        message: 'Your message was submitted with success',
        type: 'success',
      });
      return true;
    }
    catch {
      errors.value = true;
      send({
        message: 'An error occured',
        type: 'danger',
      });
      return false;
    }
    finally {
      loading.value = false;
    }
  };

  return {
    sendEmail,
    loading: computed(() => loading.value),
    errors: computed(() => errors.value),
  };
};
